module.exports = __webpack_public_path__ + "img/year-select-angle.97584121.svg";